module.exports = __webpack_public_path__ + "img/1515128055.93c53aa4.jpg";